import type { JSX } from 'react'

import { TrailerPlayerSC } from './TrailerPlayer.styled'

export interface ITrailerPlayerProps {
  setRef?: (node: HTMLDivElement | null) => void
}

export const TrailerPlayer = ({ setRef }: ITrailerPlayerProps): JSX.Element => {
  return <TrailerPlayerSC ref={setRef} />
}
